export { default } from 'ember-tether/components/ember-tether';